var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 109,
    viewBox: "0 0 88 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.125 42.0007C84.6721 43.9416 81.9909 45.5868 79.2929 46.9358C69.3361 51.9142 56.5912 54.4111 43.875 54.4111C31.1588 54.4111 18.4139 51.9142 8.45714 46.9358C5.75912 45.5868 3.07792 43.9416 0.625 42.0007V54.4111C0.625002 60.1282 5.15581 65.6339 13.2926 69.7023C21.4034 73.7577 32.4042 76.0361 43.875 76.0361C55.3458 76.0361 66.3466 73.7577 74.4574 69.7023C82.5942 65.6339 87.125 60.1282 87.125 54.4111V42.0007ZM87.125 74.4382C84.6721 76.3791 81.9909 78.0243 79.2929 79.3733C69.3361 84.3517 56.5912 86.8486 43.875 86.8486C31.1588 86.8486 18.4139 84.3517 8.45714 79.3733C5.75912 78.0243 3.07792 76.3791 0.625 74.4382V86.8486C0.625 98.7918 19.9887 108.474 43.875 108.474C67.7613 108.474 87.125 98.7918 87.125 86.8486V74.4382ZM87.125 21.9736C87.125 10.0305 67.7613 0.348633 43.875 0.348633C19.9887 0.348633 0.625 10.0305 0.625 21.9736C0.625002 27.6907 5.15581 33.1964 13.2926 37.2648C21.4034 41.3202 32.4042 43.5986 43.875 43.5986C55.3458 43.5986 66.3466 41.3202 74.4574 37.2648C82.5942 33.1964 87.125 27.6907 87.125 21.9736Z",
    fill: "#063065"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenIcon);
export default __webpack_public_path__ + "static/media/TokenIcon.1c06244523bacdd8518cee630f87d36d.svg";
export { ForwardRef as ReactComponent };